import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Report } from 'components/Report/Report';
import { convertUTCToLocalDate } from 'components/UTC/UtcConverter';
import { formatDate } from 'helper/dateFormat';
import { numberFormat } from 'helper/numberFormat';
import React from 'react';
import ExportOptions from '../../../components/ExportOptions/ExportOptions';
import "./index.scss";
export const BillingReportByAccount = ({filter,data,filterData,dateFormet,today,
    TableCellBodyTotal,TableCellBody,StyledTableRow,downloadExcel,TableCellHead,reportRows,reportDetailsRows,reportsFiltersPayload,isLoading,tableContainerRef,reportName,setIsExportLoading,reportFileNameHandler,includeAccountInformation}) => {
      const reportColumns = [
          ...(reportName === "Billing Report by Account (Family)" ? [{
          id: "accountId",
          displayName: "ACCOUNT ID",
          headerName: "Account Id",
          field: "accountId",
          flex: 1,
          },
          {
          id: "accountName",
          displayName: "ACCOUNT NAME",
          headerName: "Account Name",
          field: "accountName",
          flex: 1,
          }
          ] : [
            {
            id: "ledgerName",
            displayName: "LEDGER NAME",
            headerName: "Ledger Name",
            field: "ledgerName",
            flex: 1,
            }
          ]),
          {
          id: "billed",
          displayName: "BILLED",
          headerName: "Billed",
          field: "billed",
          flex: 1,
          },
          {
          id: "discount",
          displayName: "DISCOUNT",
          headerName: "Discount",
          field: "discount",
          flex: 1,
          },
          {
          id: "paid",
          displayName: "PAID",
          headerName: "Paid",
          field: "paid",
          flex: 1,
          },
          {
          id: "balance",
          displayName: "BALANCE",
          headerName: "Balance",
          field: "balance",
          flex: 1,
          },
          ...(includeAccountInformation ? [
            {
                id: "adult1firstName",
                displayName: "ADULT 1 FIRST NAME",
                headerName: "Adult 1 First Name",
                field: "adult1firstName",
                flex: 1,
            },
            {
                id: "adult1lastName",
                displayName: "ADULT 1 LAST NAME",
                headerName: "Adult 1 Last Name",
                field: "adult1lastName",      
                flex: 1,
            },
            {
                id: "adult2firstName",
                displayName: "ADULT 2 FIRST NAME",
                headerName: "Adult 2 First Name",
                field: "adult2firstName",
                flex: 1,
            },
            {
                id: "adult2lastName",
                displayName: "ADULT 2 LAST NAME",
                headerName: "Adult 2 Last Name",
                field: "adult2lastName",      
                flex: 1,
            },
            {
                id: "billingAddress",
                displayName: "BILLING ADDRESS",
                headerName: "Billing Address",
                field: "billingAddress",
                flex: 1,
            },
            {
                id: "billingCity",
                displayName: "BILLING CITY",
                headerName: "Billing City",
                field: "billingCity",
                flex: 1,
            },
            {
                id: "billingState",
                displayName: "BILLING STATE",
                headerName: "Billing State",
                field: "billingState",
                flex: 1,
            },
            {
                id: "billingZip",
                displayName: "BILLING ZIP CODE",
                headerName: "Billing Zip Code",
                field: "billingZip",
                flex: 1,
            },
            {
                id: "billingCountry",
                displayName: "BILLING COUNTRY",
                headerName: "Billing Country",
                field: "billingCountry",
                flex: 1,
            },
            {
                id: "adult1Mobile",
                displayName: "ADULT 1 MOBILE",
                headerName: "Adult 1 Mobile",
                field: "adult1Mobile",
                flex: 1,
            },
            {
                id: "adult2Mobile",
                displayName: "ADULT 2 MOBILE",
                headerName: "Adult 2 Mobile",
                field: "adult2Mobile",
                flex: 1,
            },
            {
                id: "adult1Email",
                displayName: "ADULT 1 EMAIL",
                headerName: "Adult 1 Email",
                field: "adult1Email",
                flex: 1,
            },
            {
                id: "adult2Email",
                displayName: "ADULT 2 EMAIL",
                headerName: "Adult 2 Email",
                field: "adult2Email",
                flex: 1,
            }, 
          ] : []),
      ];
      const reportDetailsColumns = [
           ...(reportName === "Billing Report by Account (Family)" ? [
            {
            id: "accountName",
            displayName: "ACCOUNT NAME",
            headerName: "Account Name",
            field: "accountName",
            flex: 1,
            },
            {
            id: "ledgers",
            displayName: "LEDGERS",
            headerName: "Ledgers",
            field: "ledgers",
            flex: 1,
            }
          ] : [
            {
            id: "ledgers",
            displayName: "LEDGERS",
            headerName: "Ledgers",
            field: "ledgers",
            flex: 1,
            },
            {
            id: "accountName",
            displayName: "ACCOUNT NAME",
            headerName: "Account Name",
            field: "accountName",
            flex: 1,
            }
          ]),
          {
          id: "billed",
          displayName: "BILLED",
          headerName: "Billed",
          field: "billed",
          flex: 1,
          },
          {
          id: "discount",
          displayName: "DISCOUNT",
          headerName: "Discount",
          field: "discount",
          flex: 1,
          },
          {
          id: "paid",
          displayName: "PAID",
          headerName: "Paid",
          field: "paid",
          flex: 1,
          },
          {
          id: "balance",
          displayName: "BALANCE",
          headerName: "Balance",
          field: "balance",
          flex: 1,
          },
          ...(includeAccountInformation ? [
            {   
                id: "adult1firstName",
                displayName: "ADULT 1 FIRST NAME",
                headerName: "Adult 1 First Name",
                field: "adult1firstName",
                flex: 1,
            },
            {
                id: "adult1lastName",
                displayName: "ADULT 1 LAST NAME",
                headerName: "Adult 1 Last Name",
                field: "adult1lastName",      
                flex: 1,
            },
            {
                id: "adult2firstName",
                displayName: "ADULT 2 FIRST NAME",
                headerName: "Adult 2 First Name",
                field: "adult2firstName",
                flex: 1,
            },
            {
                id: "adult2lastName",
                displayName: "ADULT 2 LAST NAME",
                headerName: "Adult 2 Last Name",
                field: "adult2lastName",      
                flex: 1,
            },
            {
                id: "billingAddress",
                displayName: "BILLING ADDRESS",
                headerName: "Billing Address",
                field: "billingAddress",
                flex: 1,
            },
            {
                id: "billingCity",
                displayName: "BILLING CITY",
                headerName: "Billing City",
                field: "billingCity",
                flex: 1,
            },
            {
                id: "billingState",
                displayName: "BILLING STATE",
                headerName: "Billing State",
                field: "billingState",
                flex: 1,
            },
            {
                id: "billingZip",
                displayName: "BILLING ZIP CODE",
                headerName: "Billing Zip Code",
                field: "billingZip",
                flex: 1,
            },
            {
                id: "billingCountry",
                displayName: "BILLING COUNTRY",
                headerName: "Billing Country",
                field: "billingCountry",
                flex: 1,
            },
            {
                id: "adult1Mobile",
                displayName: "ADULT 1 MOBILE",
                headerName: "Adult 1 Mobile",
                field: "adult1Mobile",
                flex: 1,
            },
            {
                id: "adult2Mobile",
                displayName: "ADULT 2 MOBILE",
                headerName: "Adult 2 Mobile",
                field: "adult2Mobile",
                flex: 1,
            },
            {
                id: "adult1Email",
                displayName: "ADULT 1 EMAIL",
                headerName: "Adult 1 Email",
                field: "adult1Email",
                flex: 1,
            },
            {
                id: "adult2Email",
                displayName: "ADULT 2 EMAIL",
                headerName: "Adult 2 Email",
                field: "adult2Email",
                flex: 1,
            }, 
          ] : []),
      ];
     
      const coulmns = filterData?.filter?.detailedByFamily ? reportDetailsColumns:reportColumns 
      const rows =  filterData?.filter?.detailedByFamily ? reportDetailsRows() : reportRows()
      const BillingReportheaders=filterData?.filter?.detailedByFamily ? 
      [
        ...(reportName === "Billing Report by Account (Family)" ? [
        {title:"ACCOUNT NAME",width:30},{title:"LEDGERS",width:30},
        ] : [
           {title:"LEDGERS",width:30}, {title:"ACCOUNT NAME",width:30}
        ]),

      {title:"BILLED",width:30},{title:"DISCOUNT",width:30},
      {title:"PAID",width:30},{title:"BALANCE",width:30}]:
      [
        ...(reportName === "Billing Report by Account (Family)" ? [
        {title:"ACCOUNT ID",maxWidth:33},{title:"ACCOUNT NAME",maxWidth:33},
        ] : [
            {title:"Ledger Name",maxWidth:33},
            {title:"",maxWidth:33}
        ]),

      {title:"BILLED",maxWidth:33},{title:"DISCOUNT",maxWidth:33},{title:"PAID",maxWidth:33},{title:"BALANCE",maxWidth:33}]


    const billingReportName = () => {
        let billingReportName = "";
        if(reportName === "Billing Report by Account (Family)") {
            billingReportName = filterData?.filter?.detailedByFamily  ? "Billing Report By Family By Ledger"
            : "Billing Report";
        } else if(reportName === "Billing Report by Ledger") {
            billingReportName = filterData?.filter?.detailedByFamily  ? "Billing Report By Ledger By Family"
            : "Billing Report by Ledger";
        } else {
            billingReportName = ""
        }
        return billingReportName;
    };

    const checkHeaderAlignment = (index) => {
        if (reportName === "Billing Report by Ledger" && !filterData?.filter?.detailedByFamily) {
            return index === 0 ? "left" : "right";
        } else {
            return index === 0 || index === 1 ? "left" : "right";
        }
    }
    return (
        <>
      <ExportOptions 
        columns={coulmns}
        datas={rows}
        downloadExcel={downloadExcel}
        isLoading={isLoading}
        tableContainerRef={tableContainerRef}
        setLoading={setIsExportLoading}
        reportFileNameHandler={reportFileNameHandler}
    />
    <Report 
        Title={billingReportName()}
        FromDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.start), formatType: "default"})}
        ToDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.end), formatType: "default"})}
        filterData={filterData}
        asOf={formatDate({date:convertUTCToLocalDate(today), formatType: "default"})}
        tableContainerRef={tableContainerRef}
        Content={
        <>
        <Table>
        <TableHead>
            <TableRow>
                {BillingReportheaders?.map((item, index) => (
                    <TableCellHead style={{
                        maxWidth: item?.maxWidth,
                        width: item?.width,
                        borderBottomLeftRadius:index === 0 ? 5:0,
                        borderTopLeftRadius:index === 0 ? 5:0,
                        borderBottomRightRadius:BillingReportheaders.length-1=== index ? 5:0,
                        borderTopRightRadius:BillingReportheaders.length-1=== index ? 5:0,
                        padding: "16px 7px",
                    }}
                    align={checkHeaderAlignment(index)}
                    >
                            {item?.title}
                    </TableCellHead>
                ))}
            </TableRow>
        </TableHead>
            {filterData?.filter?.detailedByFamily ?
            <TableBody style={{ backgroundColor: 'white' }}>
            {data?.[0]?.data?.map((item)=>(
                <>
                {item?.[reportName === "Billing Report by Ledger" ? "accounts" : "ledgers"]?.map((ledger, index) => (
                <StyledTableRow sx={{
                '& > *': {
                    border: 'none'
                }
            }}
            >   {reportName === "Billing Report by Account (Family)" ? (
                    <>
                    <TableCellBody
                    className="main-width-class first-cell"
                    align="left"
                    >
                    {index=== 0 ? item?.AccountName :''}
                    </TableCellBody>
                    <TableCellBody
                        className="main-width-class"
                        align="left"
                    >
                    {ledger?.ledgerName}
                    </TableCellBody>
                    </>
                ) : (
                    <>
                    <TableCellBody
                    className="main-width-class ledger-name first-cell"
                    align="left"
                    >
                    {index=== 0 ? item?.ledgerName :''}
                    </TableCellBody>
                    <TableCellBody
                        className="main-width-class"
                        align="left"
                    >
                    {ledger?.accountName}
                    </TableCellBody>
                    </>
                )}
                <TableCellBody
                    className="main-width-class"
                    align="right"
                >
                    {numberFormat({number:ledger?.billed, decimal:2, style:"currency"})}
                    
                </TableCellBody>
                <TableCellBody
                    className="main-width-class"
                    align="right"
                >
                    {numberFormat({number:ledger?.discount, decimal:2, style:"currency"})}
                </TableCellBody>
                <TableCellBody
                    className="main-width-class"
                    align="right"
                >
                    {numberFormat({number:ledger?.paid, decimal:2, style:"currency"})}
                </TableCellBody>
                <TableCellBody
                    className="main-width-class last-cell"
                    align="right"
                >
                {numberFormat({number:ledger?.balance, decimal:2, style:"currency"})}
                </TableCellBody>

            </StyledTableRow>
             ))}   
            <StyledTableRow sx={{
                '& > *': {
                    border: 'none'
                }
            }}
            >
                <TableCellBodyTotal
                    align="left"
                    style={{fontSize: '10px',padding: 7}}
                    className="first-cell table-cell-total"
                >
                    {reportName === "Billing Report by Account (Family)" ? (
                        <span style={{display: 'inline-block',width: '100%'}}>Total for {item?.AccountName} Family</span>
                            ) : (
                        <span style={{display: 'inline-block',width: '100%'}}>Total</span>
                    )}
                </TableCellBodyTotal>
                <TableCellBodyTotal
                    align="left"
                    style={{fontSize: '10px',padding: 7}}
                    className="table-cell-total"
                >
                {reportName === "Billing Report by Account (Family)" ? (
                <span>{item?.ledgers?.length} ledgers</span>
                ) : (
                <span>{item?.accounts?.length} accounts</span>
                )}
                </TableCellBodyTotal>
                <TableCellBodyTotal
                    align="right"
                    style={{fontSize: '10px',padding: 7}}
                    className="table-cell-total"

                >
                <span>{numberFormat({number:item?.totalBilled, decimal:2, style:"currency"})}</span>
                </TableCellBodyTotal>
                <TableCellBodyTotal
                    align="right"
                    style={{fontSize: '10px',padding: 7}}
                    className="table-cell-total"

                >
                <span>{numberFormat({number:item?.totalDiscount, decimal:2, style:"currency"})}</span>
                </TableCellBodyTotal>
                <TableCellBodyTotal
                    align="right"
                    style={{fontSize: '10px',padding: 7}}
                    className="table-cell-total"

                >
                <span>{numberFormat({number:item?.totalPaid, decimal:2, style:"currency"})}</span>
                </TableCellBodyTotal>
                <TableCellBodyTotal
                    align="right"
                    style={{fontSize: '10px',padding: 7}}
                    className="table-cell-total last-cell"

                >
                <span>{numberFormat({number:item?.totalBalance, decimal:2, style:"currency"})}</span>
                </TableCellBodyTotal>
            </StyledTableRow>
            </>
            ))}
            </TableBody>
            :
            <TableBody style={{ backgroundColor: 'white' }}>
                {data?.[0]?.data?.map((item)=>(
                    <StyledTableRow sx={{
                    '& > *': {
                        borderBottom: 'unset'
                    }
                }}
                >
                    {reportName === "Billing Report by Account (Family)" ? (
                        <>
                            <TableCellBody
                                className="main-width-class first-cell"
                                align="left"
                            >
                                <span className="account-id">#{item?.account?.account_id}</span> 
                            </TableCellBody>
                            <TableCellBody
                                className="main-width-class"
                                align="left"
                            >
                                <span className="name">{item?.AccountName}</span>
                            </TableCellBody>
                        </>
                    ) : (
                        <>
                            <TableCellBody
                            className="main-width-class first-cell"
                            align="left"
                            >
                                <span className="ledger-name">{item?.ledgerName}</span> 
                            </TableCellBody>
                            <TableCellBody
                            className="main-width-class ledger-item"
                            align="left"
                            >
                                <span className="ledger-name"></span> 
                            </TableCellBody>
                        </>
                    )}
                   
                    <TableCellBody
                        className="main-width-class"
                        align="right"
                    >
                        {numberFormat({number:item?.billed, decimal:2, style:"currency"})}
                    </TableCellBody>
                    <TableCellBody
                        className="main-width-class"
                        align="right"
                    >
                        {numberFormat({number:item?.discount, decimal:2, style:"currency"})}
                    </TableCellBody>
                    <TableCellBody
                        className="main-width-class"
                        align="right"
                    >
                        {numberFormat({number:item?.paid, decimal:2, style:"currency"})}
                    </TableCellBody>
                    <TableCellBody
                        className="main-width-class last-cell"
                        align="right"
                    >
                    {numberFormat({number:item?.balance, decimal:2, style:"currency"})}
                    </TableCellBody>
            
                </StyledTableRow>

                ))}
            </TableBody>
        }
        
        </Table>

        {!!data?.length && (

        <div className='total-billing-row'>
            <Table>
                <TableBody>
                <TableCellBody
                    className="main-width-class total-billing-row-title first-cell"
                    align="left"
                >
                    {}
                    <span >
                        {reportName === "Billing Report by Account (Family)" ? "Total for this report" : "Total"}</span>
                </TableCellBody>
                <TableCellBody
                    className="main-width-class"
                    align="left"
                >
                    <span >{
                            reportName === "Billing Report by Account (Family)" ? `${data?.[0]?.totalOfFamilies} families` :  `${data?.[0]?.totalOfLedgers} ledgers` 
                    }</span>
                </TableCellBody>
                <TableCellBody
                    className="main-width-class"
                    align="right"
                >
                    <span>{numberFormat({number:data?.[0]?.totalBilled, decimal:2, style:"currency"})}</span>
                </TableCellBody>
                <TableCellBody
                    className="main-width-class"
                    align="right"
                >
                    <span>{numberFormat({number:data?.[0]?.totalDiscount, decimal:2, style:"currency"})}</span>
                </TableCellBody>
                <TableCellBody
                    className="main-width-class"
                    align="right"
                >
                    <span>{numberFormat({number:data?.[0]?.totalPaid, decimal:2, style:"currency"})}</span>
                </TableCellBody>
                <TableCellBody
                    className="main-width-class last-cell"
                    align="right"
                >
                    <span>{numberFormat({number:data?.[0]?.totalBalance, decimal:2, style:"currency"})}</span>
                </TableCellBody>
                </TableBody>
            </Table>
        </div>
        )}

        </>
        }
    />
    </>
    );
};

